import React, { useContext, Fragment } from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import Data from 'Content/content.json';
import Context from '../../../context';
import { language } from 'Root/constants';

// @TODO
// Make this component having same markup

const Title = ({ lensName, lensLongName , lookIndex }) => {
  const name = lensLongName ? lensLongName : lensName;
  const { looksCleared } = useContext(Context);
  const lookName =
    lookIndex > -1 ? Data.data.looks[lookIndex][language].name : null;

  return (
    <Fragment>
      <div className="message--wrapper">
        {language === 'ja' && (
          <Fragment>
            <FormattedMessage
              id="looks.you_have_chosen"
              defaultMessage="You have chosen:"
            />
            <span
              className="text-golden"
              dangerouslySetInnerHTML={{ __html: name }}
            />
          </Fragment>
        )}
        {language !== 'ja' && (
          <Fragment>
            {
              !lensLongName ? 
              <FormattedHTMLMessage
                id="looks.you_have_chosen"
                defaultMessage="You have chosen:"
              />
              : ''
            }
            {language === 'arabia'?
            <span dangerouslySetInnerHTML={{ __html: '"'+name+'"' }} />
            : <span dangerouslySetInnerHTML={{ __html: name }} />}
            {lookName && !looksCleared && (
              <span>
                <FormattedMessage
                  id="looks.with_looks"
                  defaultMessage="With Looks:"
                />
                <span className="text-golden">
                  {lookName}
                </span>
              </span>
            )}
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};

export default Title;
